import React, {useState} from 'react';
import RLookUpModal from "../../SellFactor/FactorKOL/RLookUpModal";

const RLookupType = ({
                       row, onChange, onBlur,
                       functionAfterSelect,
                       variables,
                       className
                     }) => {


  const [isOpen, setIsOpen] = useState(false);

  try {
    return (<div>
      <>
        <button
          className={className + '  cursor__pointer bg-white'}
          onBlur={onBlur}
          // placeholder={row?.placeholder} // default caption
          // value={row.value}


          // className={"rlookup__like_select__option"}
          onClick={(e) => {

            e.preventDefault()
            setIsOpen(true)
          }}
          onKeyUp={e => {


            if (e?.key === ' ' || e?.key === 'Enter') {
              setIsOpen(true)
            }
          }}
        >
          {row?.buttonCaption}
        </button>
        <span style={{
          fontSize: 10,

        }}>
          {row['rLookUpJoinResponse']}
        </span>
      </>
      <>
        {isOpen && <RLookUpModal
          id={row.rlookupId}
          callBackDataHandler={functionAfterSelect}
          modalHandler={[isOpen, (isOpen) => setIsOpen(isOpen)]}

          variables={variables}
          variableIsStringify={!!row['conditionFields']}

        />}
      </>
    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }

}

export default RLookupType;